import { useEffect, useState } from 'react';

function useCountdown(minutes: number | string) {
    const [timeLeft, setTimeLeft] = useState<number>(+(minutes) * 60);

    useEffect(() => {
        if (timeLeft <= 0) return;

        const interval = setInterval(() => {
            setTimeLeft((prevTime) => Math.max(prevTime - 1, 0));
        }, 1000);

        return () => clearInterval(interval);
    }, [timeLeft]);

    const minutesLeft = Math.floor(timeLeft / 60);
    const secondsLeft = timeLeft % 60;

    return `${String(minutesLeft).padStart(2, '0')}:${String(secondsLeft).padStart(2, '0')}`;
}

export default useCountdown;
